/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualificationKeyValueCodeModel } from '../../models/qualification-key-value-code-model';

export interface MasterDataQualificationsQualificationTypeIdGet$Params {
  qualificationTypeId: string;
  languageRegion?: string;
}

export function masterDataQualificationsQualificationTypeIdGet(http: HttpClient, rootUrl: string, params: MasterDataQualificationsQualificationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataQualificationsQualificationTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('qualificationTypeId', params.qualificationTypeId, {});
    rb.query('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>;
    })
  );
}

masterDataQualificationsQualificationTypeIdGet.PATH = '/MasterData/Qualifications/{qualificationTypeId}';
